import { useDispatch, useSelector } from 'react-redux';

import {
  legendOptions,
} from '../SourcesLegend/source-legend.constants';
import { setSelectedMode } from '../SourcesLegend/source-legend.store';
import '../FlowingWaterLegend/flowing-water-legend.css';

const collectorLegendOptions = legendOptions.filter(
  option => option.value !== 'temperature',
);
const energyFormatter = new Intl.NumberFormat('nl-BE', {
  maximumFractionDigits: 2,
});

function getLegendValues(maximum) {
  return [
    maximum,
    maximum * 0.8,
    maximum * 0.6,
    maximum * 0.4,
    maximum * 0.2,
    0,
  ].map(value => value.toFixed(2));
}

function formatLegendValue(value) {
  return energyFormatter.format(Number(value));
}

function CollectorLegend({ maximums }) {
  const dispatch = useDispatch();
  const selectedMode = useSelector(state => state.sourceLegend.selectedMode);
  const activeMode = collectorLegendOptions.some(option => option.value === selectedMode)
    ? selectedMode
    : collectorLegendOptions[0].value;
  const maximum = maximums?.[activeMode] || 0;
  const values = getLegendValues(maximum);
  const unit = 'GWh/jaar';
  const label = `${collectorLegendOptions.find(option => option.value === activeMode).label} (${unit})`;

  return (
    <div className="flowing-water-legend">
      <div className="flowing-water-legend__switch" role="group" aria-label="Legendaweergave">
        {collectorLegendOptions.map(({ label: optionLabel, value }) => (
          <button
            className={`flowing-water-legend__switch-option${activeMode === value ? ' flowing-water-legend__switch-option--selected' : ''}`}
            key={value}
            type="button"
            aria-pressed={activeMode === value}
            onClick={() => dispatch(setSelectedMode(value))}
          >
            {optionLabel}
          </button>
        ))}
      </div>
      <div className="flowing-water-legend__scale" role="img" aria-label={label}>
        <span className="flowing-water-legend__unit">{unit}</span>
        <span className="flowing-water-legend__width-sizer" aria-hidden="true">
          <span>{formatLegendValue(values[0])}</span>
          <i className="flowing-water-legend__tick" />
        </span>
        <div className="flowing-water-legend__gradient" aria-hidden="true" />
        <div className="flowing-water-legend__labels">
          {values.map(value => (
            <div className="flowing-water-legend__label" key={value}>
              <span>{formatLegendValue(value)}</span>
              <i className="flowing-water-legend__tick" aria-hidden="true" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CollectorLegend;
